<template>
  <div>
    <div v-if="mcc">
      <h4>Details for {{mcc.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{mcc[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="mcc.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "mcc",
  components: {
    BFR
  },
  props: {
    mcc: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["manufacturerType", "Type"],
      ["ampsSupplied", "Amps Supplied"],
      ["voltsSupplied", "Volts Supplied"],
      ["phase", "Phase"],
      ["wire", "Wire"],
      ["hertz", "HZ"],
      ["catNo", "Cat. NO."],
      ["diagramNo", "Diagram NO."],
      ["number", "NO."],
      ["plant", "Plant"]
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
